<div class="col-lg-12 col-md-12 col-xs-12 padding0px">
  <div class="col-lg-12 padding0px LimitSidebar" [ngClass]="{'entended-LimitSidebar':__bIsLoadedFromDataSearch}">
    <div class="dx-field">
      <div class="dx-field-label width-100">{{__sTradingCounterparty}}</div>
    </div>
    <div class="col-md-12 col-lg-12 col-sm-12" *ngFor="let oPeriodDetail of __oPeriodDetails; let i = index;">
      <div class="dx-field">
        <div class="dx-field-label width-70">{{oPeriodDetail.PeriodName}}</div>
        <div class="dx-field-value width-30 padding-top-03rem" style="text-align: right; ">
          <a class="btn-info btn-icon">
            <span id="spDelete" (click)="btnDelete_Click($event,oPeriodDetail.PeriodName)" class="dx-icon dx-icon-trash"></span>
          </a>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label width-100">
          From: <font color="red" *ngIf="oPeriodDetail.StartDate == undefined || oPeriodDetail.StartDate == ''">*</font>       
          <div class="container" style="padding-left:1rem;">
            <div class="row">
              <dx-number-box *ngIf="__oSideBarCounterPartyLimit.TenorTypeName  == 'Rolling'"
                             [(value)]="oPeriodDetail.RollingFromPeriod"
                             [disabled]="__oSideBarCounterPartyLimit.IsTempLimit"
                             (onValueChanged)="calculateLimitPeriodFromPeriod(oPeriodDetail,'dpStartTime',$event)" class="col-lg-2 col-sm-2 col-md-2 p-0 text-align-center center">
              </dx-number-box>

              <div class="col-lg-10 col-sm-10 col-md-10 p-0" [ngClass]="(__oSideBarCounterPartyLimit.TenorTypeName == 'Rolling')?'p-2':''">
                <app-date-picker [ngClass]="__oSideBarCounterPartyLimit.TenorTypeName == 'Rolling'?'hidden':''" type="date" id="dpStartTime"
                             #dpStartTime displayFormat="monthAndYear" [value]="oPeriodDetail.StartDate" [readOnly]="false"
                             [min]="oPeriodDetail.MinStartDate" [max]="oPeriodDetail.MaxStartDate" (onDatePickerKeyDown)="stopWriting($event)"
                             [calendarOptions]="__oCalendarOptions" [disabled]="__oSideBarCounterPartyLimit.IsTempLimit"
                             (onDatePickerValueChanged)="date_ValueChanged(oPeriodDetail,'dpStartTime',$event, 'StartDate')"></app-date-picker>
                <span *ngIf="__oSideBarCounterPartyLimit.TenorTypeName == 'Rolling' && oPeriodDetail.StartDate">{{oPeriodDetail.StartDate | date: 'MMM-yyyy'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label width-100">
          To: <font color="red" *ngIf="oPeriodDetail.EndDate == undefined || oPeriodDetail.EndDate == ''">*</font>
          <div class="container" style="padding-left:1rem;">
            <div class="row">             
              <dx-number-box *ngIf="__oSideBarCounterPartyLimit.TenorTypeName  == 'Rolling'"
                             [(value)]="oPeriodDetail.RollingToPeriod"
                             (onValueChanged)="calculateLimitPeriodFromPeriod(oPeriodDetail,'dpEndTime',$event)" class="col-lg-2 col-sm-2 col-md-2 p-0 " style="text-align:center !important">
              </dx-number-box>              
              <div class="col-lg-10 col-sm-10 col-md-10 p-0" [ngClass]="(__oSideBarCounterPartyLimit.TenorTypeName == 'Rolling')?'p-2':''">
                <app-date-picker [ngClass]="__oSideBarCounterPartyLimit.TenorTypeName == 'Rolling'?'hidden':''" type="date" id="dpEndTime"
                             #dpEndTime displayFormat="monthAndYear" [value]="oPeriodDetail.EndDate" [readOnly]="false" [min]="oPeriodDetail.StartDate"
                             [max]="__dtMaxDate" (onDatePickerKeyDown)="stopWriting($event)"
                             [calendarOptions]="__oCalendarOptions" (onDatePickerValueChanged)="date_ValueChanged(oPeriodDetail,'dpEndTime',$event, 'EndDate')"></app-date-picker>
                <span *ngIf="__oSideBarCounterPartyLimit.TenorTypeName == 'Rolling' && oPeriodDetail.RollingToPeriod">{{oPeriodDetail.EndDate | date: 'MMM-yyyy'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="__oSideBarCounterPartyLimit.TradingCategoryName !== 'Overall' && __oSideBarCounterPartyLimit.TradingCategoryName!='Headroom' && __oSideBarCounterPartyLimit.LimitTypeName !== 'Volume'" class="dx-field">
        <div class="dx-field-label width-100">
          Max Limits: <br />
          <div *ngFor="let oMaxLimitMsg of oPeriodDetail.MaxLimitDetail; let i = index;">
            <span [ngClass]="{'sidebarlabelfontcolor': (oMaxLimitMsg.MaxLimitAllocation < oPeriodDetail.LimitValue && !__oSideBarCounterPartyLimit.IsTempLimit),'sidebarlabelblackfontcolor': (oMaxLimitMsg.MaxLimitAllocation > oPeriodDetail.LimitValue)}">
              {{oMaxLimitMsg.MonthName}} - {{oMaxLimitMsg.EndMonthName}} :
              <span style="display:inline-block;">{{__oSideBarCounterPartyLimit.CurrencyName}} {{oMaxLimitMsg.MaxLimitAllocation.toLocaleString()}}</span><br />
            </span>
          </div>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label width-100">
          Limit:
          <div class="container" style="padding-left:1rem;">
            <div class="row">
              <div class="col-lg-12 col-sm-12 col-md-12 p-0">
                <dx-number-box id="nbLimit" [showClearButton]="false" format="0#,###.##" [(value)]="oPeriodDetail.LimitValue"
                               (onKeyUp)="onKeyPressNumberBox($event,'nbLimit',oPeriodDetail)" (onFocusOut)="onFocusOut($event,oPeriodDetail)"
                               [ngClass]="{'sidebarNumberboxfontcolor': oPeriodDetail.IsColorChanged}"></dx-number-box>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
      <div class="dx-field" [ngClass]="{'disable-class': getDisableStatus(),'disable-class-sidebar': __bAddPeriodDisabled}">
        <table class="table">
          <tr>
            <td>
              <a class="btn-info btn-icon" id="btnAddPeriod" (click)="btnAddPeriod_Click()"
                 style="min-width: auto; ">
                <span class="dx-icon dx-icon-add"></span>
              </a>
            </td>
            <td style="width:98%; padding: 0 0 0 5px;">
              <span class="clickable" (click)="btnAddPeriod_Click()">Add another period</span>
            </td>
          </tr>
        </table>
      </div>
    </div>

  </div>
  <div class="dx-field col-lg-12 col-md-12 col-xs-12 padding0px">
    <table class="table">
      <tr>
        <td style="width:60%;border:none;padding-right:0px;"></td>
        <td style="width:20%; border:none;padding-right:5px;">
          <dx-button id="btnClose" class="btn-secondary" (onClick)="btnClose_Click()" text="Close" style="float: left;"></dx-button>
        </td>
        <td style="width:20%; padding-right:0px;">
          <dx-button id="btnApply" (onClick)="btnApply_Click()" [disabled]="getApplyDisableStatus()" text="Apply" style="float: left;"></dx-button>
        </td>

      </tr>
    </table>
  </div>

  <dx-popup [wrapperAttr]="{ class: 'popupSample' }"
            id="popupWarning"
            [width]="550"
            [height]="'auto'"
            [showTitle]="true"
            title="Limit value is blank"
            [dragEnabled]="false"
            [hideOnOutsideClick]="false"
            [(visible)]="__bWarningVisible">
    <div *dxTemplate="let data of 'content'">

      <div class="row message-border">
        <div class="col-lg-12 col-md-12 col-xs-12 message-box">
          <div id="form-limit">
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <span>Limit Value is blank and if you continue, limit values will be deleted. </span><br />
              <span>Are you sure you want to remove the limit values for the following period?  </span><br /><br />
              <div *ngFor="let oMaxLimitMsg of __oMaxLimitDetails">
                <div>
                  <div class="row" style="margin: 0px 10px; ">
                    <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
                      <span>From {{oMaxLimitMsg.StartMonthName}} - to {{oMaxLimitMsg.EndMonthName}} </span><br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin: 0px; ">
        <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
          <div class="col-lg-9 col-md-9 col-xs-9 padding0px" style="float: right;">
            <dx-button id="btnCancel" (onClick)="btnCancel_Click()" text="Cancel"></dx-button>
            <dx-button id="btnRemoveAll" (onClick)="btnRemoveAll_Click()" text="Remove All"></dx-button>
          </div>
        </div>
      </div>

    </div>
  </dx-popup>
</div>


<app-confirmation [__iPopupHeight]="'auto'"></app-confirmation>
